var map = {
	"./decorator-crowd.png": "e7ed",
	"./decorator-drums.png": "2947",
	"./decorator-guitar.png": "858a",
	"./decorator-headphones.png": "0155",
	"./decorator-mic.png": "f145",
	"./decorator-music.png": "86ac",
	"./decorator-piano.png": "565e",
	"./decorator-studio.png": "7d00",
	"./decorator-violin.png": "51b7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "eb77";